<template>
    <v-dialog v-model="dialog" max-width="756">
        <v-overlay color="#106c68" :value="callApiPending" z-index="12">
            <span class="loader"></span>
        </v-overlay>
        <v-card class="standard-row" style="padding: 20px 4.5% 20px 4.5%; border-radius: 10px; box-shadow: 0px 9px 8px rgba(0, 0, 0, 0.25);">
            <v-row no-gutters class="font-theme">
                <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11.5 1C13.9853 1 16 2.79167 16 5.0018V6.33573C16 8.54587 13.9853 10.3375 11.5 10.3375C9.01472 10.3375 7 8.54587 7 6.33573V5.0018C7 2.79167 9.01472 1 11.5 1ZM22 19.6751C22 19.3513 22 19.0275 22 18.7037C22 14.4533 16.4706 11.6715 11.5 11.6715C6.52944 11.6715 1 14.4533 1 18.7037V19.6751C1 20.4118 1.67157 21.009 2.5 21.009H20.5C21.3284 21.009 22 20.4118 22 19.6751Z" stroke="#2A2E3B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span class="ml-2" style="font-size: 20px; font-weight: 700;">เพิ่มสิทธิ์หน้า INBOX</span>
            </v-row>
            <v-row no-gutters class="font-theme mt-8" align="center" style="font-size: 18px;">
                <v-col cols="12" sm="4" md="2" lg="2">
                    บริษัท
                </v-col>
                <v-col cols="12" sm="" md="" lg="">
                    <v-autocomplete outlined hide-details dense :items="allBusiness" v-model="aboutEmp.business" item-text="first_name_th" height="31" placeholder="Dropdown" class="add-role-dropdown" append-icon="mdi-chevron-down" item-color="#D9D9D9" color="black" :menu-props="{ bottom: true, offsetY: true }" return-object>
                        <template v-slot:item="data">
                            <v-list-item-content>
                                <v-list-item-title class="font-theme" style="line-height: 30px; font-size: 16px;">{{ data.item.first_name_th }}</v-list-item-title>
                            </v-list-item-content>
                        </template>
                        <template v-slot:no-data>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title class="font-theme" style="line-height: 30px; font-size: 16px;">ไม่พบข้อมูล</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                    </v-autocomplete>
                </v-col>
            </v-row>
            <v-row no-gutters class="font-theme mt-4 mt-md-6" align="center" style="font-size: 18px;">
                <v-col cols="12" sm="12" md="6" lg="6">
                    <v-row no-gutters class="font-theme" align="center">
                        <v-col cols="12" sm="4" md="4" lg="4">
                            รหัสพนักงาน
                        </v-col>
                        <v-col cols="12" sm="8" md="8" lg="8" class="pr-md-3">
                            <v-text-field hide-details outlined height="38" :filled="aboutEmp.business.tax_id? false: true" :readonly="aboutEmp.business.tax_id? false: true" v-model="aboutEmp.employeeId" color="black" class="add-role-text-field" @input="clearDetailEmployee()" @keyup.enter="searchEmpDetail(aboutEmp.business.biz_id, aboutEmp.employeeId)">
                                <template v-slot:append>
                                    <v-btn icon @click="searchEmpDetail(aboutEmp.business.biz_id, aboutEmp.employeeId)">
                                        <v-icon size="30">mdi-magnify</v-icon>
                                    </v-btn>
                                </template>
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="6" class="mt-4 mt-md-0">
                    <v-row no-gutters class="font-theme" align="center">
                        <v-col cols="12" sm="4" md="3" lg="3" class="pl-md-3">
                            ชื่อ - สกุล
                        </v-col>
                        <v-col cols="12" sm="8" md="9" lg="9" class="pl-md-3">
                            <v-tooltip top :disabled="aboutEmp.detailEmployee.full_name_th? false :true">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field hide-details outlined filled readonly v-bind="attrs" v-on="on" v-model="aboutEmp.detailEmployee.full_name_th" height="38" color="black" class="add-role-text-field"></v-text-field>
                                </template>
                                <span class="font-theme">{{ aboutEmp.detailEmployee.full_name_th }}</span>
                            </v-tooltip>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-row no-gutters class="font-theme mt-4 mt-md-6" align="center" style="font-size: 18px;">
                <v-col cols="12" sm="12" md="6" lg="6">
                    <v-row no-gutters class="font-theme" align="center">
                        <v-col cols="12" sm="4" md="4" lg="4">
                            แผนก
                        </v-col>
                        <v-col cols="12" sm="8" md="8" lg="8" class="pr-md-3">
                            <v-tooltip top :disabled="aboutEmp.department.dept_name? false :true">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-autocomplete outlined hide-details dense v-bind="attrs" v-on="on" :items="departmentList" item-text="dept_name" :filled="aboutEmp.detailEmployee.account_id? false: true" :readonly="aboutEmp.detailEmployee.account_id? false: true" v-model="aboutEmp.department" height="31" placeholder="" class="add-role-dropdown" append-icon="mdi-chevron-down" item-color="#D9D9D9" color="black" :menu-props="{ bottom: true, offsetY: true }" return-object>
                                        <template v-slot:item="data">
                                            <v-list-item-content>
                                                <v-list-item-title class="font-theme" style="line-height: 30px; font-size: 16px;">{{ data.item.dept_name }}</v-list-item-title>
                                            </v-list-item-content>
                                        </template>
                                        <template v-slot:no-data>
                                            <v-list-item>
                                                <v-list-item-content>
                                                    <v-list-item-title class="font-theme" style="line-height: 30px; font-size: 16px;">ไม่พบข้อมูล</v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                    </v-autocomplete>
                                </template>
                                <span class="font-theme">{{ aboutEmp.department.dept_name }}</span>
                            </v-tooltip>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="6" class="mt-4 mt-md-0">
                    <v-row no-gutters class="font-theme" align="center">
                        <v-col cols="12" sm="4" md="3" lg="3" class="pl-md-3">
                            Inbox
                        </v-col>
                        <v-col cols="12" sm="8" md="9" lg="9" class="pl-md-3">
                            <v-tooltip top :disabled="aboutEmp.inbox.inbox? false :true">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-autocomplete outlined hide-details dense v-bind="attrs" v-on="on" :items="inboxList" item-text="inbox" :filled="aboutEmp.detailEmployee.account_id? false: true" :readonly="aboutEmp.detailEmployee.account_id? false: true" v-model="aboutEmp.inbox" height="31" placeholder="" class="add-role-dropdown" append-icon="mdi-chevron-down" item-color="#D9D9D9" color="black" :menu-props="{ bottom: true, offsetY: true }" return-object>
                                        <template v-slot:item="data">
                                            <v-list-item-content>
                                                <v-list-item-title class="font-theme" style="line-height: 30px; font-size: 16px;">{{ data.item.inbox }}</v-list-item-title>
                                            </v-list-item-content>
                                        </template>
                                        <template v-slot:no-data>
                                            <v-list-item>
                                                <v-list-item-content>
                                                    <v-list-item-title class="font-theme" style="line-height: 30px; font-size: 16px;">ไม่พบข้อมูล</v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                    </v-autocomplete>
                                </template>
                                <span class="font-theme">{{ aboutEmp.inbox.inbox }}</span>
                            </v-tooltip>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-row no-gutters class="font-theme mt-5 d-flex justify-center" align="center">
                <v-btn height="50" width="104" color="#0B68D6" @click="addPermission()" style="border-radius: 10px; font-size: 20px; font-weight: 600;" class="font-theme white--text">
                    ยืนยัน
                </v-btn>
            </v-row>
        </v-card>
    </v-dialog>
</template>

<script>
import { EventBus } from '../EventBus'
    export default {
        data: () => ({
            dialog: false,
            inboxList: [],
            allBusiness: [],
            callApiPending: 0,
            departmentList: [],
            aboutEmp: {
                business: {
                    "first_name_th" : null,
                    "first_name_eng" : null,
                    "tax_id" : null,
                    "biz_id" : null
                },
                employeeId: null,
                detailEmployee: {
                    "full_name_th" : null
                },
                department: {
                    "dept_id": null,
                    "dept_name": null
                },
                inbox: {
                    "dept_id": null,
                    "inbox": null
                }
            }
        }),
        mounted () {
            this.getAllBusiness()
            EventBus.$on('addPermissionInboxModal', this.openDialog)
        },
        beforeDestroy () {
            EventBus.$off('addPermissionInboxModal')
            this.callApiPending = 0
        },
        methods: {
            openDialog() {
                this.dialog = true
                this.aboutEmp = {
                    business: {
                        "first_name_th" : null,
                        "first_name_eng" : null,
                        "tax_id" : null,
                        "biz_id" : null
                    },
                    employeeId: null,
                    detailEmployee: {
                        "full_name_th" : null
                    },
                    department: {
                        "dept_id": null,
                        "dept_name": null
                    },
                    inbox: {
                        "dept_id": null,
                        "inbox": null
                    }
                }
                this.departmentList = []
                this.inboxList = []
            },
            clearDetailEmployee() {
                if (Object.keys(this.aboutEmp.detailEmployee).length > 1) {
                    this.aboutEmp.detailEmployee = { 
                        "full_name_th" : null 
                    }
                    this.aboutEmp.department = { 
                        "dept_id": null,
                        "dept_name": null
                    }
                    this.aboutEmp.inbox = { 
                        "dept_id": null,
                        "inbox": null
                    }
                    this.departmentList = []
                    this.inboxList = []
                }
            },
            async getAllBusiness() {
                try {
                    this.callApiPending++
                    this.allBusiness = []
                    const { data } = await this.axios.get(`${this.$api_url}/business/api/v1/get_bussiness_data`)
                    if (data.status && data.data.length) {
                        for (let i = 0; i < data.data.length; i++) {
                            this.allBusiness.push({
                                "first_name_th"  : data.data[i].business_detail?.name_th  || 'ไม่พบชื่อบริษัทในฐานข้อมูล',
                                "first_name_eng" : data.data[i].business_detail?.name_eng || 'Not Found Data in Database',
                                "biz_id"         : data.data[i].business_detail?.id             || null,
                                "tax_id"         : data.data[i].tax_id                          || null
                            })
                        }
                    }
                } catch (error) {
                    console.log(error)
                } finally {
                    this.callApiPending--
                }
            },
            async searchEmpDetail(biz_id, employeeId) {
                if (!biz_id) {
                    return this.alert('กรุณาเลือกบริษัท', 'Warning', 'info')
                } else if (!employeeId) {
                    return this.alert('กรอกรหัสพนักงาน', 'Warning', 'info')
                }
                try {
                    this.callApiPending++
                    const { data } = await this.axios.get(`${this.$api_url}/permission/api/v1/get_empid?biz_id=${biz_id}&emp_id=${employeeId}`)
                    if (data.status && Object.keys(data.data).length) {
                        data.data.full_name_th = `${data.data.account_title_th || ''}${data.data.first_name_th || ''} ${data.data.last_name_th || ''}`,
                        this.aboutEmp.detailEmployee = data.data
                        this.checkDepartmentAndPermission(this.aboutEmp.business.tax_id || '', data.data.account_id || '')
                    } else {
                        this.alert('ไม่พบข้อมูลพนักงาน', 'Warning', 'info')
                    }
                } catch (error) {
                    console.log(error)
                    this.alert('ไม่พบข้อมูลพนักงาน', 'Warning', 'info')
                } finally {
                    this.callApiPending--
                }
            },
            async checkDepartmentAndPermission(tax_id, account_id) {
                if (!tax_id) {
                    return this.alert('กรุณาเลือกบริษัท', 'Warning', 'info')
                }
                try {
                    this.callApiPending++
                    const { data } = await this.axios.get(`${this.$api_url}/permission/api/v1/check_department?tax_id=${tax_id}&account_id=${account_id}`)
                    if (data.status && Object.keys(data.data).length) {
                        this.departmentList      = data.data.department
                        this.aboutEmp.department = data.data.department.length ? data.data.department[0] : []
                        this.inboxList      = data.data.inbox
                        this.aboutEmp.inbox = data.data.inbox.length ? data.data.inbox[0] : []
                    } else {
                        this.alert('ไม่พบข้อมูลสิทธิ์ในระบบ', 'Warning', 'info')
                    }
                } catch (error) {
                    console.log(error)
                    this.alert('ไม่พบข้อมูลสิทธิ์ในระบบ', 'Warning', 'info')
                } finally {
                    this.callApiPending--
                }
            },
            async addPermission() {
                if (!this.aboutEmp.business.tax_id) {
                    return this.alert('กรุณาเลือกบริษัท', 'Warning', 'info')
                } else if (Object.keys(this.aboutEmp.detailEmployee).length <= 1 || !this.aboutEmp.employeeId) {
                    return this.alert('กรอกรหัสพนักงาน และกดค้นหา', 'Warning', 'info')
                } else if (this.aboutEmp.business.tax_id === '0107544000094' && (!this.aboutEmp.department.dept_id || !this.aboutEmp.department.dept_name)) {
                    return this.alert('กรุณาเลือกแผนก', 'Warning', 'info')
                } else if (!this.aboutEmp.inbox.dept_id || !this.aboutEmp.inbox.inbox) {
                    return this.alert('กรุณาเลือกสิทธิ์', 'Warning', 'info')
                }
                try {
                    const body = {
                        "tax_id"        : this.aboutEmp.business.tax_id           || null,
                        "account_id"    : this.aboutEmp.detailEmployee.account_id || null,
                        "emp_id"        : this.aboutEmp.employeeId                || null,
                        "business_name" : this.aboutEmp.business.first_name_th    || this.aboutEmp.business.first_name_eng || null,
                        "emp_name"      : {
                            "first_name_th"     : this.aboutEmp.detailEmployee.first_name_th     || null,
                            "last_name_th"      : this.aboutEmp.detailEmployee.last_name_th      || null,
                            "first_name_eng"    : this.aboutEmp.detailEmployee.first_name_eng    || null,
                            "last_name_eng"     : this.aboutEmp.detailEmployee.last_name_eng     || null,
                            "account_title_th"  : this.aboutEmp.detailEmployee.account_title_th  || null,
                            "account_title_eng" : this.aboutEmp.detailEmployee.account_title_eng || null
                        },
                        "permission"    : this.aboutEmp.inbox      || null,
                        "department"    : this.aboutEmp.department || null
                    }
                    this.callApiPending++
                    const { data } = await this.axios.post(`${this.$api_url}/permission/api/v1/add_permission`, body)
                    if (data.status && data.message.toLowerCase().replace(/ /g, "") === "createsuccess") {
                        EventBus.$emit('AfterAddPermission')
                        this.dialog = false
                        this.alert('เพิ่มสิทธิ์สำเร็จ', 'Success', 'success')
                    } else {
                        this.alert('ไม่ตรงเงื่อนไขการเพิ่มสิทธิ์', 'Warning', 'info')
                    }
                } catch (error) {
                    if (!error.response.data.status && error.response.data.message.toLowerCase().replace(/ /g, "") === "havepermissionalready") {
                        this.alert('มีสิทธิ์เดิมอยู่แล้ว', 'Warning', 'info')
                    } else {
                        console.log(error)
                        this.alert('ไม่ตรงเงื่อนไขการเพิ่มสิทธิ์', 'Warning', 'info')
                    }
                } finally {
                    this.callApiPending--
                }
            },
            alert(title = '', text = '', icon = 'info') {
                this.$swal({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    icon: icon,
                    title: `<b class="alert-success-title">${title}</b>`,
                    text:  text,
                    showClass: {
                        popup: 'animate-show-card'
                    },
                    customClass: {
                        container: 'alert-card-block',
                        popup: 'alert-card-success',
                        title: 'alert-title-block',
                        htmlContainer: 'alert-text-box',
                        icon: 'alert-icon'
                    }
                });
            }
        }
    }
</script>

<style>
    .add-role-text-field .v-input__control .v-input__slot {
        min-height: auto;
    }

    .add-role-text-field {
        border-radius: 10px;
    }

    .add-role-text-field input {
        line-height: 30px;
    }

    .add-role-dropdown {
        border-radius: 10px;
    }

    .add-role-dropdown input {
        line-height: 30px;
    }
    
    .add-role-dropdown .v-icon.v-icon {
        margin-top: 15px;
        margin-right: -7px;
    }

    .add-role-text-field .v-input__control .v-input__slot .v-input__append-inner {
        margin-top: 1px;
        margin-right: -11px;
    }

    .loader {
        width: 16px;
        height: 16px;
        box-shadow: 0 30px, 0 -30px;
        border-radius: 4px;
        background: currentColor;
        display: block;
        margin: -50px auto 0;
        position: relative;
        color: #FFF;
        transform: translateY(30px);
        box-sizing: border-box;
        animation: animationLoader 2s ease infinite;
    }

    .loader::after, .loader::before {
        content: '';  
        box-sizing: border-box;
        width: 16px;
        height: 16px;
        box-shadow: 0 30px, 0 -30px;
        border-radius: 4px;
        background: currentColor;
        color: #FFF;
        position: absolute;
        left: 30px;
        top: 0;
        animation: animationLoader 2s 0.2s ease infinite;
    }

    .loader::before {
        animation-delay: 0.4s;
        left: 60px;
    }

    @keyframes animationLoader {
        0% {
            top: 0;
            color: white;
        }
        50% {
            top: 30px;
            color: rgba(255, 255, 255, 0.2);
        }
        100% {
            top: 0;
            color: white;
        }
    }
</style>